import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class FieldRenderService {
  activeRenderId = ''
  constructor() {}

  setActiveId(id: string) {
    this.activeRenderId = id
  }
}
